import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails, PassengerResponseDTO } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetPassengersNoClientsByLastNameCommand extends IRequestCommand<
  IGetPassengersNoClientsByLastNameResponse,
  ErrorDetails,
  IGetPassengersNoClientsByLastNameParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/noClients?lastName=';
  override _needAuthenticate = true;

  public override setParameters(
    parameters: IGetPassengersNoClientsByLastNameParameters
  ) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId
    );
    this._commandUrl = this._commandUrl + parameters.lastName;
  }
}

export interface IGetPassengersNoClientsByLastNameParameters
  extends ICommandParameters {
  carrierUserId: string;
  lastName: string;
}

export interface IGetPassengersNoClientsByLastNameResponse
  extends ICommandResponse {
  passengers?: PassengerResponseDTO[];
}
